module.exports = __webpack_public_path__ + "static/media/chains.8d6fec86.png";